import { Controller } from "@hotwired/stimulus"
import StimulusReflex from 'stimulus_reflex';
export default class extends Controller {
  
  connect() {
       StimulusReflex.register(this);
/*
       this.autoRefreshPage = setInterval(() => {
	     console.log("refreshing")
         this.stimulate();
       }, 5000)
       */
  }
  
  disconnect() {
	  //clearInterval(this.autoRefreshPage);
  }    
}

